import {buildHistoryPoint} from "@js/globalFunctions/buildHistoryHandling";

window.onbeforeunload = function(){
    var now = new Date();
    var time = now.getTime();
    time += 600 * 1000;
    now.setTime(time);
    document.cookie = 'isRefreshed='+window.location.href+'; expires=' + now.toUTCString() + ';path=/';
}
buildHistoryPoint(window.location.href);
